import { CheckIcon } from "../../icons";

export const CustomerIsRenterScreen = () => {
  return (
    <div className="tw-max-w-[822px] tw-mx-auto tw-text-center tw-bg-white tw-rounded md:tw-px-[190px] tw-px-10 tw-py-10 tw-mt-24 tw-text-blue">
      <div className="tw-flex tw-items-center tw-justify-center tw-text-[#00AEEF]">
        <CheckIcon />
      </div>
      <div className="tw-text-3xl tw-font-bold tw-mt-5">Thank you for your inquiry</div>
      <div className="tw-text-xl tw-mt-5">
        <p className="tw-mt-5">
          One of our product specialists will be in touch within one business day.
        </p>
        <p className="tw-mt-5 tw-text-base">
          Renting? Share this with your landlord. Rental property owners can
          qualify for the same heat pump incentives.
        </p>
      </div>
    </div>
  );
};
